import { UrlQueryFilter } from "../../../../../shared/hooks/useUrlQuery";

// Payee-side work log tab filter status
// Maps to the backend WorkLogStatus enum (when available)
export enum WorkLogPayeeTabFilterStatus {
  InProgress = "in-progress", // Includes both Draft and InProgress work logs
  Submitted = "submitted", // Submitted - awaiting payer approval (backend: InReview)
  Approved = "approved", // Approved - invoice created
  Rejected = "rejected" // Rejected - terminal state
}

export interface Filter extends UrlQueryFilter {
  status?: WorkLogPayeeTabFilterStatus;
  assignmentId?: string;
}
